import React from 'react';
import { Button } from 'antd';
import PPAOnboardingHeader from 'components/PPAOnboardingHeader';
import { CALENDLY_LINK } from 'constants/common';
import s from './s.module.less';

interface FlowShellProps {
    children: React.ReactNode;
    onExit: () => void;
    onBack: () => void;
    // Primary advance action lives in the footer bar (Back | Next), matching the prototype.
    // Omit `primaryLabel` for steps that render their own in-content action (e.g. Select providers).
    primaryLabel?: string;
    primaryDisabled?: boolean;
    onPrimary?: () => void;
}

// Immersive full-screen chrome shared by the group credentialing flow and the add-providers page:
// Klarity top bar, scrollable content, and a footer bar with Save-and-exit / Back / primary.
const FlowShell: React.FC<FlowShellProps> = ({
    children,
    onExit,
    onBack,
    primaryLabel,
    primaryDisabled,
    onPrimary,
}) => (
    <div className={s.page}>
        <div className={s.topBar}>
            <PPAOnboardingHeader webinarLink={CALENDLY_LINK.KLARITY_BILLING_WEBINAR} />
        </div>

        <div className={s.contentArea}>{children}</div>

        <div className={s.footer}>
            <Button className={s.exitBtn} onClick={onExit}>
                Save and exit
            </Button>
            <div className={s.footerRight}>
                <Button type="link" className={s.backBtn} onClick={onBack}>
                    Back
                </Button>
                {primaryLabel && (
                    <Button type="primary" className={s.primaryBtn} disabled={primaryDisabled} onClick={onPrimary}>
                        {primaryLabel}
                    </Button>
                )}
            </div>
        </div>
    </div>
);

export default FlowShell;
